<template>
  <div>
    <v-card>
      <v-card-title>
        <v-layout row wrap align-center>
          <v-flex xs12>
            <v-toolbar flat color="white">
              <v-toolbar-title>Transfer Token</v-toolbar-title>
              <v-divider class="mx-2" inset vertical></v-divider>
              <TransferTokenDialog
                :searchForm="searchForm"
                :filterList="filterListForm"
                :searchQueueList="searchQueueListForm"
                :isLoading="isLoading"
                :headers="headers1"
                :queueList="queueList"
                @onOK="initialize()"
              />
            </v-toolbar>
          </v-flex>
        </v-layout>
      </v-card-title>
      <TransferTokenQueueTable
        :isLoading="isLoading"
        :searchForm="searchForm"
        :filterList="filterList"
        :searchQueueList="searchQueueList"
        :headers="headers"
        :queueList="queueList"
      />
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TransferTokenQueueTable from "@/components/back-office/TransferTokenQueue/TransferTokenQueueTable.vue";
import TransferTokenDialog from "@/components/back-office/TransferTokenQueue/TransferTokenDialog.vue";
export default {
  data() {
    return {
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
        },
        {
          text: "Type",
          align: "center",
          sortable: false,
          value: "",
        },

        {
          text: "Wallet address",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Point",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Token",
          align: "center",
          sortable: false,
          value: "",
        },
        { text: "Status", align: "center", sortable: false, value: "" },
        {
          text: "Reference name",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Reference source",
          align: "center",
          sortable: false,
          value: "",
        },
        { text: "", align: "center", sortable: false, value: "" },
      ],
      headers1: [
        {
          text: "Type",
          align: "center",
          sortable: false,
          value: "",
        },

        {
          text: "Wallet address",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Point",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Token",
          align: "center",
          sortable: false,
          value: "",
        },
        { text: "Status", align: "center", sortable: false, value: "" },
        {
          text: "Reference name",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Reference source",
          align: "center",
          sortable: false,
          value: "",
        },
        { text: "", align: "center", sortable: false, value: "" },
      ],
      isLoading: false,
      levelList: [
        {
          name: "Standard",
          value: 1,
        },
        {
          name: "Silver",
          value: 2,
        },
        {
          name: "Gold",
          value: 3,
        },
        {
          name: "Platinum",
          value: 4,
        },
        {
          name: "VIP",
          value: 5,
        },
      ],
      categoryList: [
        {
          name: "Food delivery",
          value: 1,
        },
        {
          name: "Messenger",
          value: 2,
        },
      ],
      orderList: [
        {
          name: "Food delivery",
          value: 1,
        },
        {
          name: "Messenger",
          value: 2,
        },
      ],
      unitList: [
        {
          name: "%",
          value: 2,
        },
        {
          name: "฿",
          value: 1,
        },
      ],
      searchForm: {
        searchedCode: "",
        searchedName: "",
        searchedWalletAddress: "",
        searchedType: "",
        filterStatus: -1,
        filterStatusForm: -1,
      },
      filterList: [
        {
          name: "All Status",
          value: -1,
        },
        {
          name: "Pending",
          value: 1,
        },
        {
          name: "Success",
          value: 2,
        },
        {
          name: "Failed",
          value: 3,
        },
        {
          name: "Canceled",
          value: 4,
        },
      ],
      filterListForm: [
        {
          name: "All Status",
          value: -1,
        },
        {
          name: "Pending",
          value: 1,
        },
        {
          name: "Failed",
          value: 3,
        },
      ],
    };
  },
  components: {
    TransferTokenQueueTable,
    TransferTokenDialog,
  },
  computed: {
    ...mapState({
      queueList: (state) => state.crypto.transferTokenQueueList,
    }),
    searchQueueList() {
      return this.queueList.filter(
        (val) =>
          val.queue_code
            .toLowerCase()
            .includes(this.searchForm.searchedCode.toLowerCase()) &&
          val.queue_type
            .toLowerCase()
            .includes(this.searchForm.searchedType.toLowerCase()) &&
          val.queue_name
            .toLowerCase()
            .includes(this.searchForm.searchedName.toLowerCase()) &&
          val.queue_user_wallet_address
            .toLowerCase()
            .includes(this.searchForm.searchedWalletAddress.toLowerCase()) &&
          (this.searchForm.filterStatus == -1 ||
            this.searchForm.filterStatus == val.queue_status)
      );
    },
    searchQueueListForm() {
      return this.queueList.filter(
        (val) =>
          val.queue_status != 4 &&
          val.queue_status != 2 &&
          val.queue_code
            .toLowerCase()
            .includes(this.searchForm.searchedCode.toLowerCase()) &&
          val.queue_type
            .toLowerCase()
            .includes(this.searchForm.searchedType.toLowerCase()) &&
          val.queue_name
            .toLowerCase()
            .includes(this.searchForm.searchedName.toLowerCase()) &&
          val.queue_user_wallet_address
            .toLowerCase()
            .includes(this.searchForm.searchedWalletAddress.toLowerCase()) &&
          (this.searchForm.filterStatusForm == -1 ||
            this.searchForm.filterStatusForm == val.queue_status)
      );
    },
  },
  methods: {
    ...mapActions({
      fetchTokenQueueList: "crypto/fetchTokenQueueList",
    }),
    async initialize() {
      this.isLoading = true;
      await this.fetchTokenQueueList();
      this.isLoading = false;
    },
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "App Campaign Reward",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  created() {
    this.initialize();
  },
};
</script>

<style lang="scss" scoped>
</style>